/**
 * GB phone formats. The payments-service prefixes +44 only when the number starts with "0", so a
 * national number written without the leading zero reaches Stripe unqualified and is rejected.
 * Both "07911 123456" and "+44 7911 123456" are accepted here.
 *
 * Ofcom reserves 07700 900000-900999 for testing, and Stripe accepts that range.
 */
const UnitedKingdomValidation = {
  'ez-mail': /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  'required-phone-mask': /^(?:\+44 ?|0)(?:\d ?){9,10}$/,
  'optional-phone-mask': /^$|^(?:\+44 ?|0)(?:\d ?){9,10}$/,
  'mobile-mask': /^(?:\+44 ?7|07)(?:\d ?){9}$/,
  'mobile-and-phone-mask': /^(?:\+44 ?|0)(?:\d ?){9,10}$/,
};

export default UnitedKingdomValidation;
